export default "__VITE_ASSET__CuLWO2ju__"